import React, { useContext, useMemo, useState } from 'react';
import { RenderEditable, RenderControl, RenderElement } from 'components/RenderHelpers';
import { FormViewContent, FormSubtitle } from 'components/FormViewContent';
import { BoolToString, CTSUCardActions } from 'components';
import { ListItem, ListItemText } from '@material-ui/core';
import { MUISelect, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import { openSnackbar } from 'helpers/Notifier';
import { useFormik } from 'formik';
import { getAdminInfoSelector } from '../../../../reducers/protocols/admin/adminReducer';
import { updateAdminFieldsAction } from '../../../../actions/protocols/admin';

const ExclusionsEditMode = ({ setEditMode, isProd }) => {
    const initialValues = useSelector(getAdminInfoSelector);
    const context = useContext(AppContext);
    const dispatch = useDispatch();
    const actions = useMemo(() => bindActionCreators({ updateAdminFieldsAction }, dispatch), [dispatch]);

    const onClickSave = (data) => {
        bindLogger(actions.updateAdminFieldsAction, context)({
            ...data,
            isStartSync: data.isStartSync ? 'Y' : 'N'
        }).subscribe(() => {
            setEditMode(false);
            openSnackbar({
                message: 'Admin Flags updated successfully.',
                variant: 'success',
                name: 'open'
            });
        });
    }

    const formIk = useFormik({
        initialValues: {
            isStartSync: initialValues.isStartSync === 'Y',
            isCTRBSubmission: initialValues.isCTRBSubmission,
            isDtlRequired: initialValues.isDtlRequired
        },
        onSubmit: onClickSave
    });

    const { values, handleSubmit, handleChange, resetForm } = formIk;

    return <ValidatorForm onSubmit={handleSubmit}>
        <FormSubtitle paddingClass="MuiListSubheader-gutters pb-0">Exclusions</FormSubtitle>
        <FormViewContent
            primaryText="Exclude from START Sync?"
            secondaryText={(
                <MUISelect
                    name="isStartSync"
                    value={!!values.isStartSync}
                    onChange={handleChange}
                // className={classes.editable}
                >
                    <ListItem button value>
                        <ListItemText primary="Yes" />
                    </ListItem>
                    <ListItem button value={false}>
                        <ListItemText primary="No" />
                    </ListItem>
                </MUISelect>
            )}
        />
        <FormViewContent
            primaryText="Exclude from CTRP Submission?"
            secondaryText={(
                <MUISelect
                    name="isCTRBSubmission"
                    value={!!values.isCTRBSubmission}
                    onChange={handleChange}
                >
                    <ListItem button value>
                        <ListItemText primary="Yes" />
                    </ListItem>
                    <ListItem button value={false}>
                        <ListItemText primary="No" />
                    </ListItem>
                </MUISelect>
            )}
        />
        {isProd ? null : <>
            <FormSubtitle paddingClass="MuiListSubheader-gutters pb-0">DTL Override</FormSubtitle>
            <FormViewContent
                primaryText="DTL Required?"
                secondaryText={(
                    <MUISelect
                        name="isDtlRequired"
                        value={!!values.isDtlRequired}
                        onChange={handleChange}
                    >
                        <ListItem button value>
                            <ListItemText primary="Yes" />
                        </ListItem>
                        <ListItem button value={false}>
                            <ListItemText primary="No" />
                        </ListItem>
                    </MUISelect>
                )}
            />
        </>}
        <CTSUCardActions
            clearClick={() => resetForm()}
            cancelClick={() => { resetForm(); setEditMode(false); }}
            disabled={false}
        />
    </ValidatorForm>
}

const AdminDtlAndExclusions = () => {
    const [editMode, setEditMode] = useState(false);
    const initialValues = useSelector(getAdminInfoSelector);
    const context = useContext(AppContext);
    const {application: {dbName}} = context;
    const isProd = dbName === 'ctsu';

    return <RenderControl
        isLoading={false}
        iserror={false}
        compName="Admin Flags"
        permission
    >
        <RenderEditable
            state={editMode}
            editable
            setState={setEditMode}
            title="Admin Flags"
        >
            <RenderElement access={!editMode}>
                <FormSubtitle paddingClass="MuiListSubheader-gutters pb-0">Exclusions</FormSubtitle>
                <FormViewContent
                    primaryText="Exclude from START Sync?"
                    secondaryText={
                        <BoolToString boolValue={initialValues.isStartSync === 'Y'} />
                    }
                />
                <FormViewContent
                    primaryText="Exclude from CTRP Submission?"
                    secondaryText={
                        <BoolToString boolValue={initialValues.isCTRBSubmission} />
                    }
                />
                {
                    isProd ? null :
                        <>
                            <FormSubtitle paddingClass="MuiListSubheader-gutters pb-0">DTL Override</FormSubtitle>
                            <FormViewContent
                                primaryText="DTL Required?"
                                secondaryText={
                                    <BoolToString boolValue={initialValues.isDtlRequired} />
                                }
                            />
                        </>
                }
            </RenderElement>
            <RenderElement access={editMode}>
                <ExclusionsEditMode setEditMode={setEditMode} isProd={isProd} />
            </RenderElement>

        </RenderEditable>
    </RenderControl>
};

export default AdminDtlAndExclusions;